"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeForAppLoginRequest = void 0;
var GetPhoneDynamicCodeForAppLoginRequest = /** @class */ (function () {
    function GetPhoneDynamicCodeForAppLoginRequest() {
    }
    return GetPhoneDynamicCodeForAppLoginRequest;
}());
exports.GetPhoneDynamicCodeForAppLoginRequest = GetPhoneDynamicCodeForAppLoginRequest;
;
//# sourceMappingURL=getPhoneDynamicCodeForAppLogin.request.js.map